export default __webpack_public_path__ + "/assets/vivi-pacchetti-arredo-trilocale-lg.jpg";